import gql from 'graphql-tag';

export default gql`
  mutation adminArchiveSchool($schoolId: ID!) {
    adminArchiveSchool(schoolId: $schoolId) {
      id
    }
  }
`;
